import React, { useState } from 'react'
import { useStyles } from './ActiviteStyle'
import SouscriptionModale from '../SouscriptionModale/SouscriptionModale'
import { jsPDF } from 'jspdf'
import { useSnackbar } from 'notistack'

//Material UI
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import DescriptionIcon from '@material-ui/icons/Description'
import IconButton from '@material-ui/core/IconButton'
import Chip from '@material-ui/core/Chip'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import Tooltip from '@material-ui/core/Tooltip'

export default function Activite(props) {

  const classes = useStyles()
  const { nom, category, list, saisons, setReload } = props
  const [modale, setModale] = useState(false)
  const [modaleInfos, setModaleInfos] = useState({})
  const { enqueueSnackbar } = useSnackbar()

  /**
   * Generate the pdf of the "recu"
   * @param {*} recu 
   */
  function generateRecu(recu) {

    const doc = new jsPDF()
    doc.setFontSize(10)
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth()
    let ypos = 10
    const step = 5


    doc.text('AnimaNICE', pageWidth / 2, 10, 'center')
    ypos += step

    //centre
    doc.text('Centre :', (pageWidth / 2), ypos, 'right')
    doc.text(recu.CNT_LIBELLE, (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    doc.text(recu.CNT_ADRESSE ?? '', (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    doc.line(5, ypos, pageWidth - 5, ypos)
    ypos += step

    //recu
    doc.text('Recu numéro', (pageWidth / 2), ypos, 'right')
    doc.text(recu.REC_NUMERORECU, (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    const date = new Date(recu.SOU_DATE[0])
    date.setHours(date.getHours() - 2)
    doc.text(` édité le ${date.toLocaleDateString()} à ${date.toLocaleTimeString()}
    `, pageWidth / 2, ypos, 'center')
    ypos += step - 2
    doc.line(5, ypos, pageWidth - 5, ypos)
    ypos += step

    //activité
    doc.text('Abonné :', (pageWidth / 2), ypos, 'right')
    doc.text(recu.LICI_NUMERO, (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    doc.text('Nom :', (pageWidth / 2), ypos, 'right')
    doc.text(recu.LICI_NOM + ' ' + recu.LICI_PRENOM, (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    doc.text('Catégorie :', (pageWidth / 2), ypos, 'right')
    doc.text(recu.CAT_LIBELLE, (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    doc.text('Activité :', (pageWidth / 2), ypos, 'right')
    doc.text(recu.ACT_LIBELLE, (pageWidth / 2) + 4, ypos, 'left')
    ypos += step

    if (recu.cours) {
      const deb = timeFormat(recu.cours.CO_HEUREDEBUT)
      const fin = timeFormat(recu.cours.CO_HEUREFIN)
      doc.text('Créneau :', (pageWidth / 2), ypos, 'right')
      doc.text(`Le ${recu.cours.JOUR_LIBELLE} de ${deb} à ${fin}`, (pageWidth / 2) + 4, ypos, 'left')
      ypos += step
    }

    if (recu.ACT_TA_ID !== 5) {
      doc.text('Périodicité :', (pageWidth / 2), ypos, 'right')
      doc.text(recu.PER_LIBELLE, (pageWidth / 2) + 4, ypos, 'left')
      ypos += step
    }
    doc.text('Début de validité :', (pageWidth / 2), ypos, 'right')
    doc.text(new Date(recu.REC_DATEDEBUT).toLocaleDateString(), (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    doc.text('Fin de validité :', (pageWidth / 2), ypos, 'right')
    doc.text(new Date(recu.REC_DATEFIN).toLocaleDateString(), (pageWidth / 2) + 4, ypos, 'left')
    ypos += step
    doc.line(5, ypos, pageWidth - 5, ypos)
    ypos += step


    //reports
    if (recu.reports.length > 0) {
      doc.text('Reports', pageWidth / 2, ypos, 'center')
      ypos += step - 2
      doc.line(5, ypos, pageWidth - 5, ypos)
      ypos += step
    }
    for (let rep of recu.reports) {
      const date = new Date(rep.REP_DATEOPERATION)
      doc.text(`Reporté le ${new Date(rep.REP_DATEOPERATION).toLocaleDateString()} à ${date.getHours()}:${date.getMinutes()} par ${rep.USR_MATRICULE}`, pageWidth / 2, ypos, 'center')
      ypos += step
      doc.text('Ancienne fin de validité :', (pageWidth / 2), ypos, 'right')
      doc.text(new Date(rep.REP_OLD_DATEFIN).toLocaleDateString(), (pageWidth / 2) + 4, ypos, 'left')
      ypos += step
      doc.text('Nouvelle fin de validité :', (pageWidth / 2), ypos, 'right')
      doc.text(new Date(rep.REP_NEW_DATEFIN).toLocaleDateString(), (pageWidth / 2) + 4, ypos, 'left')
      ypos += step
      doc.text('Motif :', (pageWidth / 2), ypos, 'right')
      doc.text(rep.RAI_LIBELLE ?? '', (pageWidth / 2) + 4, ypos, 'left')
      ypos += step
      doc.line(5, ypos, pageWidth - 5, ypos)
      ypos += step
    }


    //paiement
    doc.text('Somme Encaissée', pageWidth / 2, ypos, 'center')
    ypos += step - 2
    doc.line(5, ypos, pageWidth - 5, ypos)
    ypos += step

    doc.text(`Montant 1 : ${recu.REC_MONTANT1}€`, (pageWidth / 2) - 40, ypos, 'left')
    doc.text('Mode Paiement : ' + recu.MODE_LIBELLE[0], (pageWidth / 2) + 20, ypos, 'left')
    ypos += step

    doc.text(`Montant 2 : ${recu.REC_MONTANT2}€`, (pageWidth / 2) - 40, ypos, 'left')
    doc.text('Mode Paiement : ' + recu.MODE_LIBELLE[1], (pageWidth / 2) + 20, ypos, 'left')
    ypos += step
    doc.line(5, ypos, pageWidth - 5, ypos)
    ypos += step


    //prelevements
    if (recu.prelevements.length > 0) {
      doc.text('Prélèvements', pageWidth / 2, ypos, 'center')
      ypos += step - 2
      doc.line(5, ypos, pageWidth - 5, ypos)
      ypos += step
    }
    for (let pre of recu.prelevements) {
      doc.text(`Le ${new Date(pre.PRELEV_DATE).toLocaleDateString()} prélèvement de ${pre.PRELEV_MONTANT} €`, pageWidth / 2, ypos, 'center')
      ypos += step
    }


    doc.save(`RECU_${recu.REC_NUMERORECU}.pdf`)
  }

  function renouveler(recu) {
    // TODO: a faire
    const oldDateFin = new Date(recu.REC_DATEFIN)
    const dateDeb = new Date() > oldDateFin ? new Date() : oldDateFin

    const form = {
      activite: recu.ACT_ID,
      categorie: recu.SOU_CAT_ID,
      centre: recu.CNT_ID,
      date: dateDeb,
      periode: recu.PER_ID,
      typeAbo: recu.SOU_TYPECAR_ID
    }

    if (!dateAsSaison(form.date) && form.periode === 3) {
      return enqueueSnackbar('Pas de saison disponible pour cette date', { variant: `error` })
    }


    form.dateFin = calculateEndDate(form.date, form.periode)

    setModaleInfos({
      cours: { ACT_LIBELLE: recu.ACT_LIBELLE, CO_ACT_ID: recu.ACT_ID, ...recu.cours },
      centre: recu.CNT_LIBELLE,
      liID: recu.LICI_ID,
      categorie: recu.CAT_LIBELLE,
      typeAbo: recu.TYPECAR_LIBELLE,
      price: recu.REC_MONTANT,
      data: { pLibelle: recu.PER_LIBELLE, ...form }
    })
    setModale(true)
  }

  function calculateEndDate(startDate, periode) {
    let date = new Date(startDate)
    switch (periode) {
    case 1: // Mois
      date.setMonth(date.getMonth() + 1)
      break
    case 2: // Trimestre
      date.setMonth(date.getMonth() + 3)
      break
    case 3: // Saison
      const saison = dateAsSaison(date)
      if (saison) date = new Date(saison.fin)
      break
    case 4: // Année
      date.setMonth(date.getMonth() + 12)
      break
    case 5: // Ponctuelle
      date.setDate(date.getDate() + 1)
      break
    default:
      date.setMonth(date.getMonth() + 1)
      break
    }
    return date
  }

  function dateAsSaison(date) {
    let d = new Date(date)
    for (let s of saisons) {
      const deb = new Date(s.debut)
      const fin = new Date(s.fin)
      if (d > deb && d < fin) {
        return s
      }
    }

    return false
  }


  /**
   * Format the time of a date
   * @param {Date} heure 
   * @returns a string of the time
   */
  function timeFormat(heure) {
    const d = new Date(heure)
    d.setHours(d.getHours() - 1)
    const h = (d.getHours() > 9) ? d.getHours() : '0' + d.getHours()
    const m = (d.getMinutes() > 9) ? d.getMinutes() : '0' + d.getMinutes()
    return `${h}:${m}`
  }

  return (
    <div className={classes.root}>
      <h3 className={classes.title}>{nom} <Chip label={category} size="small" /></h3>
      <TableContainer component={Paper} >
        <Table size="small">
          <TableHead className={classes.head}>
            <TableRow>
              <TableCell>N° Reçu</TableCell>
              <TableCell>Activité</TableCell>
              <TableCell>Abonné</TableCell>
              <TableCell>Début</TableCell>
              <TableCell>Fin</TableCell>
              <TableCell>Montant total</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list.map((a, i) =>
              <TableRow key={i}>
                <TableCell>{a.REC_NUMERORECU}</TableCell>
                <TableCell>{a.ACT_LIBELLE}</TableCell>

                <TableCell><div className={classes.truncate}>{a.LICI_NOM} {a.LICI_PRENOM}</div></TableCell>
                <TableCell>{new Date(a.REC_DATEDEBUT).toLocaleDateString()}</TableCell>
                <TableCell>{new Date(a.REC_DATEFIN).toLocaleDateString()}</TableCell>
                <TableCell>{a.REC_MONTANT}€</TableCell>
                <TableCell>
                  <div style={{ display: 'flex' }}>
                    <Tooltip placement="bottom" title="Imprimer reçu" arrow={true}>
                      <IconButton onClick={() => generateRecu(a)} size="small"><DescriptionIcon fontSize="default" /></IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            )}

          </TableBody>
        </Table>
      </TableContainer>

      <SouscriptionModale
        modale={modale}
        setModale={setModale}
        timeFormat={timeFormat}
        modaleInfos={modaleInfos}
        setReload={setReload}
      />
    </div>
  )
}
